import React, {Fragment} from 'react';
import i18n from 'i18next';
import Embedded from '@/Layouts/Embedded';
import ValidationErrors from '@/Components/ValidationErrors';
import {Head, Link, usePage} from '@inertiajs/inertia-react';
import {FormInput, PhoneOrEmailInput} from "@/Components/Controls";
import ProductLogo from "@/Components/ProductLogo";
import styles from "@/../sass/webview/components/ResetPassword.module.scss"
import usePasswordStateManager from "@/Hooks/usePasswordStateManager";
import {ApplicationViewType} from "@/Enums/ApplicationViewType";

export default function ResetPassword({token, email_or_phone}) {
    const {data, validationState, onChange, post, processing, errors}
        = usePasswordStateManager(ApplicationViewType.EMBEDDED, {'email_or_phone':email_or_phone, 'token': token});

    const organization = usePage().props.organization;
    const loginMethod = usePage().props.login_method ?? 'email';

    const submit = (e) => {
        e.preventDefault();

        post(route('embedded.password.update', organization.uuid));
    };

    return (
        <Embedded>
            <Head title="Reset Password"/>
            <form onSubmit={submit}>
                <ProductLogo />
                <ValidationErrors errors={errors}/>
                <Fragment>
                    <div className={styles.instructions}>{i18n.t(`reset-password.${loginMethod}.reset-password-with-token`)}</div>
                    <FormInput
                        error={errors["token"]}
                        name="token"
                        isFocused={true}
                        value={data.token}
                        onChange={onChange}
                        label={i18n.t(`reset-password.${loginMethod}.token`)}
                        className="col-12"
                        dataQa="reset-password-token"
                    />
                    <div className="row">
                        <PhoneOrEmailInput
                            error={errors["email_or_phone"]}
                            name="email_or_phone"
                            value={data.email_or_phone}
                            onChange={onChange}
                            label={i18n.t("forgot-password.email-or-phone")}
                            className="col-12"
                            dataQa="reset-password-email"
                        />
                    </div>
                    <div className="row">
                        <FormInput
                            error={errors["password"]}
                            format="password"
                            name="password"
                            value={data.password}
                            onChange={onChange}
                            label={i18n.t("reset-password.password")}
                            className="col-12"
                            dataQa="reset-password-password"
                        />
                    </div>
                    <div className={`row ${styles.validationList}`}>
                        {validationState.validationItems.map((item, index) =>
                            <div
                                key={index}
                                className={`col-xs-12 ${styles.listItem} ${item.valid ? styles.success : ''} ${index % 2 ? 'col-sm-7' : 'col-sm-5'}`}
                            >
                                {
                                    item.valid !== null ?
                                        item.valid ? <i className={`fas fa-check ${styles.faCheck}`}></i> : <i className={`fas fa-times-circle ${styles.faError}`}></i>
                                        : <i className={`fas fa-circle ${styles.faCircle}`}></i>
                                }
                                <span> {item.name}</span>
                            </div>
                        )}
                    </div>
                    <div className="row">
                        <FormInput
                            error={errors["password_confirmation"]}
                            format="password"
                            name="password_confirmation"
                            value={data.password_confirmation}
                            onChange={onChange}
                            label={i18n.t("reset-password.confirm-password")}
                            className="col-12"
                            dataQa="reset-password-confirm-password"
                        />
                    </div>
                    <button
                        type="submit"
                        className="w-100 btn btn-primary"
                        disabled={!validationState.passwordIsValid || processing}
                    >
                        {i18n.t("reset-password.done")}
                    </button>
                    <Link href={route('embedded.password.request', organization.uuid)} className={styles.tryAnotherWay}>
                        {i18n.t("forgot-password.try-another-way")}
                    </Link>
                </Fragment>
            </form>
        </Embedded>
    );
}
